import { usePromotionCampaignSync } from "@/hooks";

// Renders nothing. It exists so the campaign-feed invalidation listener is
// mounted for the whole app rather than only on the promotions page: the
// lobby's promo carousel shows the same campaigns off the same query key.
// Must sit inside SocketProvider.
export default function PromotionSync() {
  usePromotionCampaignSync();
  return null;
}
